export default __webpack_public_path__ + "images/a4d6d1bf6e549a8a159b7a8da04c8e71-2_web_1919x543.jpg";